import { Controller } from "@hotwired/stimulus";
import {
  adminNavigationElement,
  adminNavigationHeight,
  emailVisibleContentOffset,
} from "../../../../javascript/includes/emailLayout";

export default class extends Controller {
  static targets = ["header", "heading", "notice", "emailCount"];

  connect () {
    this.listingTitle = document.querySelector("[data-test-id=\"listing-header-title\"]");
    this.navigation = adminNavigationElement();

    this.resizeObserver = new ResizeObserver(this.updateLayout);
    [this.navigation, this.headerTarget].filter(Boolean).forEach(element => {
      this.resizeObserver.observe(element);
    });

    this.updateLayout();

    // The email thread controller lives on a sibling subtree (#conversation), not an ancestor,
    // so a bubbling DOM event from it only reaches a document-level listener here.
    document.addEventListener("email-thread:loaded", this.updateEmailCount);
  }

  disconnect () {
    this.observer?.disconnect();
    this.resizeObserver?.disconnect();
    document.documentElement.style.removeProperty("--email-visible-content-offset");
    document.removeEventListener("email-thread:loaded", this.updateEmailCount);
  }

  updateLayout = () => {
    const navHeight = adminNavigationHeight();

    this.headerTarget.style.top = `${navHeight}px`;
    document.documentElement.style.setProperty(
      "--email-visible-content-offset",
      `${emailVisibleContentOffset()}px`,
    );

    if (!this.listingTitle || navHeight === this.observedNavHeight) return;

    this.observer?.disconnect();
    this.observer = new IntersectionObserver(this.updateHeader, {
      rootMargin: `${-navHeight}px 0px 0px 0px`,
    });
    this.observer.observe(this.listingTitle);
    this.observedNavHeight = navHeight;
  };

  updateHeader = ([entry]) => {
    this.headingTarget.classList.toggle("hidden", entry.isIntersecting);
    this.noticeTarget.classList.toggle("hidden", !entry.isIntersecting);
  };

  updateEmailCount = ({ detail: { total, loaded } }) => {
    if (!this.hasEmailCountTarget) return;

    const label = total === 1 ? "email" : "emails";
    this.emailCountTarget.textContent = loaded >= total ? `${total} ${label}` : `${loaded} of ${total} ${label}`;
  };
}
